
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTwowayDigitalStatic as ObiTwowayDigitalStaticElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-twoway-digital-static.js';
 
 
 

 
 export const ObiTwowayDigitalStatic = createComponent({
   react: React,
   tagName: 'obi-twoway-digital-static',
   elementClass: ObiTwowayDigitalStaticElement,
   events: {
     
   }
  });
 
 